import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "request-mr-example-container-form tw-flex tw-flex-col"
};
var _hoisted_2 = {
  class: "tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-gap-x-5px"
};
var _hoisted_3 = {
  class: "tw-mt-5px tw-basis-full sm:tw-basis-1/2"
};
var _hoisted_4 = {
  class: "tw-mt-5px tw-basis-full sm:tw-basis-1/2"
};
var _hoisted_5 = {
  class: "tw-flex tw-flex-wrap sm:tw-flex-nowrap sm:tw-mt-5px tw-gap-x-5px"
};
var _hoisted_6 = {
  class: "tw-mt-5px tw-basis-full sm:tw-basis-1/2"
};
var _hoisted_7 = {
  class: "tw-mt-5px tw-basis-full sm:tw-basis-1/2"
};
var _hoisted_8 = {
  class: "tw-basis-full tw-mt-10px tw-text-left"
};
var _hoisted_9 = {
  class: "tw-mt-20px tw-mb-30px tw-text-12"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  class: "tw-flex"
};
var _hoisted_12 = {
  class: "tw-basis-full sm:tw-basis-1/2 tw-mx-auto tw-relative"
};
var _hoisted_13 = {
  key: 0,
  innerHTML: 'Richiesta inviata con successo'
};
var _hoisted_14 = ["innerHTML"];
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
import { ref, watch, onBeforeMount } from "vue";
import { sendGAEvent } from "@utils/GaEvents";
import { useValidator } from "@wkComposables/useValidator";
import { useVuelidate } from "@vuelidate/core";
import { required, email, numeric, alpha, helpers } from "@vuelidate/validators";
import { useMetadataStore } from "@wkWebSrc/js/store";
import md5 from "blueimp-md5";
import { sendMrExampleRequest } from "@services/requestAPI";
export default /*#__PURE__*/_defineComponent({
  __name: 'RequestMrExampleForm',
  props: {
    labels: {},
    isMrModal: {
      type: Boolean,
      default: true
    }
  },
  emits: ["closed"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var alphaWithSpaces = helpers.regex(/^[a-zA-Z\s]+$/);
    var props = __props;
    var requestData = ref({
      name: "",
      agency: "",
      phone: "",
      email: "",
      reportTypology: {
        id: "",
        label: ""
      },
      privacy: null
    });
    var v$ = useVuelidate({
      requestData: {
        name: {
          required,
          alpha
        },
        agency: {
          required,
          alphaWithSpaces
        },
        phone: {
          required,
          numeric
        },
        email: {
          required,
          email
        },
        reportTypology: {},
        privacy: {
          required,
          mustBeTrue: v => v
        }
      }
    }, {
      requestData
    });
    var {
      isValid
    } = useValidator();
    var reportTypologyList = [{
      id: "1",
      label: props.labels.buyer_mr
    }, {
      id: "2",
      label: props.labels.seller_mr
    }, {
      id: "3",
      label: props.labels.both_mr
    }];
    var submittingMrExampleRequest = ref(false);
    var mrExampleRequestSuccessSent = ref(false);
    var showMrExampleRequestGenericError = ref(false);
    var mrFormInteracted = ref(false);
    var mdStore = useMetadataStore();
    onBeforeMount(() => {
      mdStore.setLocation(props.isMrModal ? "Modale Richiedi Report di esempio" : "Form Richiedi Report di esempio");
    });
    var emits = __emit;
    watch(() => requestData.value.reportTypology, () => {
      mrFormInteracted.value = true;
    });
    watch(mrFormInteracted, cur => {
      if (cur) sendGAEvent("mr_form_interaction", {
        event_location: "".concat(mdStore.pageName, " - ").concat(mdStore.location)
      });
    });
    var mrExampleRequest = () => __awaiter(this, void 0, void 0, function* () {
      if (requestData.value.privacy === null) requestData.value.privacy = false;
      var isFormValid = yield v$.value.$validate();
      if (!isFormValid) return;
      submittingMrExampleRequest.value = true;
      var data = {
        name: requestData.value.name,
        agency: requestData.value.agency,
        phone: requestData.value.phone,
        email: requestData.value.email,
        reportTypologyID: requestData.value.reportTypology.id,
        privacy: requestData.value.privacy
      };
      try {
        sendGAEvent("mr_lead", {
          event_location: "".concat(mdStore.pageName, " - ").concat(mdStore.location),
          user_name: data.name,
          user_email_hashed: md5(data.email),
          user_email: data.email,
          user_company_name: data.agency,
          user_phone: md5(data.phone)
        });
        yield sendMrExampleRequest({
          name: data.name,
          agency: data.agency,
          phone: data.phone,
          email: data.email,
          reportTypologyID: data.reportTypologyID ? data.reportTypologyID : "3",
          privacy: data.privacy
        });
        showAlertAndClose();
      } catch (e) {
        showMrExampleRequestGenericError.value = true;
      } finally {
        submittingMrExampleRequest.value = false;
      }
    });
    var showAlertAndClose = () => {
      mrExampleRequestSuccessSent.value = true;
      setTimeout(() => {
        onClosed();
      }, 3000);
    };
    var onClosed = () => {
      emits("closed");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("form", {
        onSubmit: _withModifiers(mrExampleRequest, ["prevent"]),
        onKeydown: _cache[8] || (_cache[8] = _withModifiers($event => mrFormInteracted.value = true, ["stop"]))
      }, [_createElementVNode("div", _hoisted_1, [_createCommentVNode(" FIRST ROW "), _createElementVNode("div", _hoisted_2, [_createCommentVNode(" NAME "), _createElementVNode("div", _hoisted_3, [_createVNode(BaseInput, {
        modelValue: requestData.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => requestData.value.name = $event),
        "is-valid": _unref(isValid)(_unref(v$).requestData.name),
        "data-cy": "name-input",
        type: "name",
        name: "name",
        feedback: {
          valid: '',
          invalid: ''
        },
        "label-text": _ctx.labels.name
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "label-text"])]), _createCommentVNode(" AGENCY "), _createElementVNode("div", _hoisted_4, [_createVNode(BaseInput, {
        modelValue: requestData.value.agency,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => requestData.value.agency = $event),
        "is-valid": _unref(isValid)(_unref(v$).requestData.agency),
        "data-cy": "agency-input",
        type: "agency",
        name: "agency",
        feedback: {
          valid: '',
          invalid: ''
        },
        "label-text": _ctx.labels.agency
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "label-text"])])]), _createCommentVNode(" SECOND ROW "), _createElementVNode("div", _hoisted_5, [_createCommentVNode(" EMAIL "), _createElementVNode("div", _hoisted_6, [_createVNode(BaseInput, {
        modelValue: requestData.value.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => requestData.value.email = $event),
        "is-valid": _unref(isValid)(_unref(v$).requestData.email),
        "data-cy": "email-input",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_mail
        },
        type: "email",
        name: "email",
        "label-text": _ctx.labels.email
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" PHONE "), _createElementVNode("div", _hoisted_7, [_createVNode(BaseInput, {
        modelValue: requestData.value.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => requestData.value.phone = $event),
        "is-valid": _unref(isValid)(_unref(v$).requestData.phone),
        "data-cy": "phone-input",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_phone
        },
        type: "tel",
        name: "phone",
        "label-text": _ctx.labels.phone
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])])]), _createCommentVNode(" REPORT TYPOLOGY "), _createElementVNode("div", _hoisted_8, [_createVNode(AccessibleSelect, {
        namespace: "typology-mr-example",
        "data-cy": "mr-report-typology-select",
        label: _ctx.labels.report_typology,
        name: "typology-mr-example",
        for: "typology-mr-example",
        "model-value": requestData.value.reportTypology,
        options: reportTypologyList,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = value => requestData.value.reportTypology = value),
        onClick: _cache[5] || (_cache[5] = $event => mrFormInteracted.value = true)
      }, null, 8 /* PROPS */, ["label", "model-value"])])]), _createCommentVNode(" PRIVACY "), _createElementVNode("div", _hoisted_9, [_createVNode(CheckboxBtn, {
        id: "checkbox",
        modelValue: requestData.value.privacy,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => requestData.value.privacy = $event),
        "is-valid": requestData.value.privacy,
        "data-cy": "privacy-checkbox",
        "container-class": "!tw-mr-5px",
        class: "!tw-pl-15px",
        label: _ctx.labels.read_and_accept,
        inline: true,
        onClick: _cache[7] || (_cache[7] = $event => mrFormInteracted.value = true)
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "label"]), _createTextVNode(" ("), _createElementVNode("a", {
        class: "tw-underline",
        href: "#",
        onclick: "(function(e){e.preventDefault(); window.open('/privacy','_blank', 'scrollbars=yes, width=550, height=600'); })(event)",
        innerHTML: _ctx.labels.privacy
      }, null, 8 /* PROPS */, _hoisted_10), _createTextVNode(") ")]), _createCommentVNode(" SUBMIT BTN "), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(BaseButton, {
        "data-cy": "request-mr-submit-btn",
        "btn-class": "tw-btn-w-primary btn-aira tw-w-full max-sm:tw-my-20px",
        type: "submit",
        "is-loading": submittingMrExampleRequest.value,
        disabled: mrExampleRequestSuccessSent.value
      }, {
        default: _withCtx(() => [mrExampleRequestSuccessSent.value ? (_openBlock(), _createElementBlock("span", _hoisted_13)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          innerHTML: _ctx.labels.request_report
        }, null, 8 /* PROPS */, _hoisted_14))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-loading", "disabled"])])])], 32 /* NEED_HYDRATION */);
    };
  }
});